import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import BodyConditionInput from './../../components/BodyConditionInput/BodyConditionInput';
import * as actionTypes from './../../store/actions/bodyConditionAction';
import fetchBodyConditionAction from './../../store/actions/fetch/fetchBodyConditionAction';
import Loader from './../../components/Loader/Loader';

/**
 * Body Condition container
 */
class BodyCondition extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  calculateIdealBodyWeight = (currentBodyWeight, bcs) => {
    if (!currentBodyWeight || !bcs) return 0;
    return ((100 * currentBodyWeight) / ((bcs - 5) * 10 + 100));
  }

  render() {
    const {data, error, pending, selectedBodyWeight, bcs, casuistic,
      onSelectBodyWeight, defaultValues, ready} = this.props;

    const idealBodyWeight = this.calculateIdealBodyWeight(selectedBodyWeight, bcs);

    // If there is a need for default data
    if(!ready && !error && !pending) {
      defaultValues();
    }
    // If data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-body-condition-input__wrapper'>
        {error && <span className='nppe2-fc-body-condition-input__error'>{error}</span>}
        {!error &&
        <BodyConditionInput data={data}
          selectedBodyWeight={selectedBodyWeight}
          onSelectBodyWeight={onSelectBodyWeight}
          idealBodyWeight={idealBodyWeight}
          bcs={bcs}
          casuistic={casuistic}
        />
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedBodyWeight: state.bodyConditionReducer.selectedBodyWeight,
    error: state.bodyConditionReducer.error,
    data: state.bodyConditionReducer.data,
    pending: state.bodyConditionReducer.pending,
    ready: state.bodyConditionReducer.ready,
    bcs: state.conditionScoreReducer.selected,
    casuistic: state.calculateDerReducer.data.casuistic,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchBodyConditionAction
      },
      dispatch,
    ),
    onSelectBodyWeight: (id) => dispatch({
      type: actionTypes.SELECT_BODY_WEIGHT,
      selectedBodyWeight: id,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(BodyCondition);
